import { Injectable, signal } from "@angular/core";

/**
 * Scoped service provided by the chat host component to share the chat instance's
 * agent/thread identity with descendant components (the background-job completion callback
 * reads `agentId`/`threadId` to refresh the parent thread).
 *
 * The former `stateSnapshot` signal was removed (chat-snapshot-stream-reducer S5): state
 * snapshots now reach the content-block rendering through the agent event stream —
 * `onStateSnapshotEvent` → ContentBlockStreamService.store() → `computed()` — never through
 * component inputs or a mirrored component effect.
 *
 * Must be provided at the chat host component level (not root) so the scope
 * is limited to one chat instance.
 */
@Injectable()
export class ChatContextService {
  /** Agent ID of the chat instance that owns this context. Set by the chat host. */
  readonly agentId = signal<string | undefined>(undefined);

  /** Active thread ID for this chat instance. Set by the chat host. */
  readonly threadId = signal<string | undefined>(undefined);
}
